import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
import { AuthService } from './auth.service';
import { TokenService } from './token.service';
import { UserService } from './user.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthService, private tokenService: TokenService,
              private userService: UserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.userService.user;
    const authToken = route.queryParams.authToken;
    const customerId = route.queryParams.customerId;
    if (authToken) {
      const extras = { queryParams: {authToken, customerId}};
      const url = location.pathname;
      this.redirectToLoginAndClearStorage(url, extras);
    } else if (user && this.tokenService.token && (user.isStrategiesUser())) {
      return true;
    } else {
      this.redirectToLoginAndClearStorage();
      return false;
    }
  }

  private redirectToLoginAndClearStorage(url: string = null, extras: NavigationExtras = {}): void {
    console.log('CLEARING LOCAL STORAGE - 6');
    localStorage.clear();
    this.authService.redirectUrl = url;
    this.router.navigate(['/login'], extras);
  }
}
